// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c1d0f35a","977":"dd2af882"}[chunkId] + ".chunk.js";
};